import React from 'react';
import { CONSTANTS } from '../config/constants';
import CircularProgress from 'material-ui/CircularProgress';

let product = window.location.href
  .split('/')
  .slice(-1)[0]
  .toUpperCase();

function LoadingView(props) {
  const placeholder =
    product === 'PEDS'
      ? require(`../images/peds-icon@3x.png`)
      : product === 'PA'
        ? require(`../images/pa-icon@3x.png`)
        : product === 'EM' ? require(`../images/EM-icon@3x.png`) : null;
  return (
    <div className="center-content screen-height">
      <div className="center-content-horizontal loading">
        {!props.loading ? (
          <div>
            <div
              className={`default-image-wrapper${
                Object.keys(CONSTANTS.PRODUCT_ID)
                  .map(p => p.toLowerCase())
                  .indexOf(product.toLowerCase()) > 0
                  ? ''
                  : ' hide'
              }`}
            >
              <img alt="" className="loading-image" src={placeholder} />
            </div>
            <p className="welcome-subtitle">WELCOME TO THE</p>
            <p className="welcome-title">{`${product === 'PA' ? '' : 'Hippo '}${
              product === 'EM'
                ? 'EM '
                : product === 'PEDS'
                  ? 'Peds '
                  : product === 'PA' ? 'AAPA PANCE/PANRE ' : ''
            }Qbank`}</p>
          </div>
        ) : (
          <CircularProgress size={60} thickness={7} color="#95BF5E" />
        )}
      </div>
    </div>
  );
}

export default LoadingView;

// QuestionCountProgress.propTypes = {
//   completed: React.PropTypes.bool.isRequired,
// };



// WEBPACK FOOTER //
// ./src/components/Loading.js